import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopNavigator from "../components/TopNavigator";
import { clearUserSession, fetchUserPortalDetails } from "../utils/userPortalApi";
import CallIcon from "../Images/Icons/Call.png";
import MessageIcon from "../Images/Icons/Message.png";
import WebsiteIcon from "../Images/Icons/Website.png";
import WhatsAppIcon from "../Images/Icons/WhatsApp.png";

function isUserLoggedIn() {
  return Boolean(localStorage.getItem("token") && localStorage.getItem("user"));
}

function SupportIcon({ type }) {
  const icons = {
    phone: CallIcon,
    whatsapp: WhatsAppIcon,
    sms: MessageIcon,
    website: WebsiteIcon,
  };

  return <img src={icons[type]} alt="" aria-hidden="true" />;
}

function SettingsPage() {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(() => isUserLoggedIn());
  const [error, setError] = useState("");
  const [authError, setAuthError] = useState(false);
  const [preferences, setPreferences] = useState({
    hideBalances: false,
    compactCards: false,
    enableNotifications: true,
  });
  const navigate = useNavigate();
  const isLoggedIn = isUserLoggedIn();

  useEffect(() => {
    if (!isLoggedIn) {
      setAuthError(false);
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const data = await fetchUserPortalDetails();
        setDetails(data);
        setAuthError(false);
      } catch (err) {
        setAuthError(true);
        setError(err.message || "خطا در دریافت اطلاعات تنظیمات");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [isLoggedIn]);

  useEffect(() => {
    try {
      const savedPreferences = localStorage.getItem("userSettings");
      if (savedPreferences) {
        setPreferences((prev) => ({
          ...prev,
          ...JSON.parse(savedPreferences),
        }));
      }
    } catch (err) {
      console.error("Error parsing user settings:", err);
    }
  }, []);

  const hasValidUser = Boolean(isLoggedIn && details?.user && !authError);
  const shouldShowLogout = !hasValidUser;
  const shouldShowLoginPrompt = !hasValidUser;
  const shouldShowBlockingError = Boolean(error && !authError);

  const updatePreference = (key) => {
    setPreferences((prev) => {
      const next = {
        ...prev,
        [key]: !prev[key],
      };
      localStorage.setItem("userSettings", JSON.stringify(next));
      return next;
    });
  };

  const handleLogout = () => {
    clearUserSession();
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container UserPortalPage">

        <section className="UserPortalPanel">
          {loading ? (
            <p className="UserPortalEmpty">در حال دریافت اطلاعات...</p>
          ) : shouldShowBlockingError ? (
            <p className="UserPortalEmpty UserPortalError">{error}</p>
          ) : (
            <div className="UserSettingsStack">
              {authError && <p className="UserPortalEmpty UserPortalError">{error}</p>}

              {shouldShowLoginPrompt && (
                <section className="UserSettingsSection UserSettingsLoginSection">
                  <div className="UserSettingsHeading">
                    <span>ورود</span>
                    <strong>برای دسترسی کامل وارد شوید</strong>
                  </div>
                  <p>
                    برای مشاهده کیف پول، گردش حساب، ثبت حواله و جزئیات حساب باید قبلا وارد حساب کاربری شده باشید.
                  </p>
                  <Link to="/loginpage" className="UserSettingsLoginBtn">
                    ورود به حساب
                  </Link>
                </section>
              )}

              <section className="UserSettingsSection">
                <div className="UserSettingsHeading">
                  <span>تنظیمات سریع</span>
                  <strong>نمایش و اعلان‌ها</strong>
                </div>

                <div className="UserSettingsList">
                  <button
                    type="button"
                    className={preferences.hideBalances ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("hideBalances")}
                  >
                    <span>
                      <strong>مخفی‌کردن موجودی‌ها</strong>
                      <small>برای حفظ حریم خصوصی در محیط عمومی</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>

                  <button
                    type="button"
                    className={preferences.compactCards ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("compactCards")}
                  >
                    <span>
                      <strong>نمایش فشرده کارت‌ها</strong>
                      <small>مناسب صفحه‌های کوچک‌تر و مرور سریع</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>

                  <button
                    type="button"
                    className={preferences.enableNotifications ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("enableNotifications")}
                  >
                    <span>
                      <strong>اعلان‌های داخل مرورگر</strong>
                      <small>برای تغییر وضعیت معامله و حواله</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>
                </div>
              </section>

                  {shouldShowLogout && (
                  <section className="UserSettingsSection UserSettingsDanger">
                    <div className="UserSettingsHeading">
                      <span>امنیت</span>
                      <strong>خروج از حساب</strong>
                    </div>
                    <p>
                      با خروج، نشست فعلی شما از این دستگاه پاک می‌شود و برای ورود دوباره باید شماره تماس و رمز عبور را وارد کنید.
                    </p>
                    <button type="button" className="UserSettingsLogout" onClick={handleLogout}>
                      خروج از حساب
                    </button>
                  </section>
                  )}

              <section className="UserSettingsSection UserSettingsSupport">
                <div className="UserSettingsHeading">
                  <span>پشتیبانی</span>
                  <strong>خرید نسخه و دمو رایگان</strong>
                </div>
                <p>
                  برای خرید نسخه و دریافت دمو رایگان با ما تماس بگیرید.
                </p>
                <div className="UserSettingsSupportActions">
                  <a href="tel:09220382792" aria-label="تماس تلفنی">
                    <SupportIcon type="phone" />
                  </a>
                  <a
                    href="https://wa.me/989220382792"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="ارسال پیام واتساپ"
                  >
                    <SupportIcon type="whatsapp" />
                  </a>
                  <a href="sms:09220382792" aria-label="ارسال پیامک">
                    <SupportIcon type="sms" />
                  </a>
                  <a
                    href="https://asgarpourgold.ir/Archavive/zarbar-plus.html"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="وب‌سایت"
                  >
                    <SupportIcon type="website" />
                  </a>
                </div>
              </section>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default SettingsPage;
